import { useQuery } from "@tanstack/react-query";

import { dashboardKeys } from "@/lib/queryKeys";
import { getDashboard, getExchangeRates } from "@/services/dashboardService";

const DASHBOARD_POLL_INTERVAL_MS = 15_000;

export function useDashboardMetrics() {
  return useQuery({
    queryKey: dashboardKeys.metrics(),
    queryFn: getDashboard,
    staleTime: 30 * 1000,
    refetchInterval: DASHBOARD_POLL_INTERVAL_MS,
  });
}

export function useExchangeRates() {
  return useQuery({
    queryKey: dashboardKeys.exchangeRates(),
    queryFn: () => getExchangeRates(),
    staleTime: 15 * 60 * 1000,
  });
}
